import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';


@Injectable({
  providedIn: 'root'
})
export class EventService {

  nodeMiddleSubject = new Subject<any>();

  constructor() { }

  emitNodeMiddle(nodeMiddle: any, that: any) {
    this.nodeMiddleSubject.next({nodeMiddle: nodeMiddle, that: that});
  }
}
